import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, patch, get, ServiceResult, post } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetSavedCreditCardsApiParameter extends ApiParameter {
    page?: number;
    pageSize?: number;
    source?: string;
}

//CreditCardDtoCollection --- P21 Change on interfaces
interface addBankAccountStates {
    "id": string,
    "name": string,
    "abbreviation": string
}
export interface BankAccountInterface {
    "accountType": string,
    "email": string,
    "termsAgreementPDFPath": string,
    "customerName": string,
    "accountDescription": string,
    "routineNumber": string,
    "bankAccountNumber": string,
    "companyName": string,
    "address1": string,
    "address2": string,
    "city": string,
    "stateProv": string,
    "zipCode": string,
    "states": addBankAccountStates[],
    "termsAgreed": string
}
export interface States {
    abbreviation: string;
    id: string;
    name: string;
    properties: object | null;
    uri: string;
}

export interface Country {
    abbreviation: string;
    id: string;
    name: string;
    properties: object | null;
    states: States | null;
    uri: string;
}

export interface ValidateAddressInterface {
    address1?: string;
    address2?: string;
    city?: string;
    companyName?: string;
    postalCode?: string;
    country?: Country;
    state?: object | string | null;
}

// GetSavedCreditCardsModel
export interface GetSavedBankAccountsModel extends BaseModel {
    uri: string,
    bankPaymentInfomration: BankAccountInterface[],
    properties: any;
}

// UpdateSavedCreditCardsApiParameter
type AddBankAccountApiParameter = BankAccountInterface & ApiParameter;
// ValidateAddresss Api Parameter
type ValidateAddressApiParameter = ValidateAddressInterface & ApiParameter;
// UpdateSavedCreditCardsModel
type BankAccountModel = BankAccountInterface & BaseModel;

const getUrl = "/api/v2/bankdetails";
const AddUrl = "/api/v2/addbankdetails";
const ValidateAddressUrl = '/api/v1/validateaddress';

// getSavedCreditCards
export async function getSavedBankAccounts(): Promise<GetSavedBankAccountsModel> {
    try {
        const savedBankAccountResults = await get<GetSavedBankAccountsModel>(getUrl);
        return savedBankAccountResults;
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return error.errorJson.message;
        }
        throw error;
    }
}

export async function addBankAccount(
    parameter: any,
): Promise<any> {
    try {
        const addBankAccountResult = await patch<BankAccountModel>(`${AddUrl}`, parameter);
        return {
            result: addBankAccountResult,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

// added this method to validate the address --P21 change
export async function validateAddress(
    parameter: any,
): Promise<any> {
    try {
        const validateAddressResult = await post<any>(`${ValidateAddressUrl}`, parameter);
        return {
            result: validateAddressResult,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}